module.exports = __webpack_public_path__ + "img/daNang.e0f198e0.jpg";